import { Produit } from '../../habilitation/models/produit.model';
import { TypeChangementProduitCode } from './enums/type-changement-produit-code.enum';
export class ProduitDestination {
    static jsonMap = {
        idProduit: { key: 'idProduit' },
        codeProduit: { key: 'codeProduit', optional: true, default: '' },
        typeChangement: { key: 'libelleTypeChangement', optional: true, default: '' },
        codeTypeChangement: { key: 'codeTypeChangement', optional: true }
    };

    idProduit: number;
    codeProduit: string;
    typeChangement: string;
    codeTypeChangement: TypeChangementProduitCode;

    produit: Produit = new Produit();
}
